function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgRain1 = function SvgRain1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FCB641"
    },
    cx: 341.632,
    cy: 136.468,
    r: 136
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M89.992,479.532c-1.352,0-2.728-0.344-3.992-1.072c-3.832-2.208-5.136-7.104-2.928-10.928l28-48.496 c2.208-3.824,7.096-5.152,10.928-2.928c3.832,2.208,5.136,7.104,2.928,10.928l-28,48.496 C95.448,478.1,92.76,479.532,89.992,479.532z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M137.992,479.532c-1.352,0-2.728-0.344-3.992-1.072c-3.832-2.208-5.136-7.104-2.928-10.928 l28-48.496c2.208-3.824,7.088-5.152,10.928-2.928c3.832,2.208,5.136,7.104,2.928,10.928l-28,48.496 C143.448,478.1,140.76,479.532,137.992,479.532z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M185.992,479.532c-1.352,0-2.728-0.344-3.992-1.072c-3.832-2.208-5.136-7.104-2.928-10.928 l28-48.496c2.208-3.824,7.088-5.152,10.928-2.928c3.832,2.208,5.136,7.104,2.928,10.928l-28,48.496 C191.448,478.1,188.76,479.532,185.992,479.532z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M233.992,479.532c-1.352,0-2.728-0.344-3.992-1.072c-3.832-2.208-5.136-7.104-2.928-10.928 l28-48.496c2.208-3.824,7.096-5.152,10.928-2.928c3.832,2.208,5.136,7.104,2.928,10.928l-28,48.496 C239.448,478.1,236.76,479.532,233.992,479.532z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M281.992,479.532c-1.352,0-2.728-0.344-3.992-1.072c-3.832-2.208-5.136-7.104-2.928-10.928 l28-48.496c2.208-3.824,7.088-5.152,10.928-2.928c3.832,2.208,5.136,7.104,2.928,10.928l-28,48.496 C287.448,478.1,284.76,479.532,281.992,479.532z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M329.992,479.532c-1.352,0-2.728-0.344-3.992-1.072c-3.832-2.208-5.136-7.104-2.928-10.928 l28-48.496c2.208-3.824,7.088-5.152,10.928-2.928c3.832,2.208,5.136,7.104,2.928,10.928l-28,48.496 C335.448,478.1,332.76,479.532,329.992,479.532z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M377.992,479.532c-1.352,0-2.728-0.344-3.992-1.072c-3.832-2.208-5.136-7.104-2.928-10.928 l28-48.496c2.216-3.824,7.096-5.152,10.928-2.928c3.832,2.208,5.136,7.104,2.928,10.928l-28,48.496 C383.448,478.1,380.76,479.532,377.992,479.532z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92C7D3"
    },
    d: "M426.208,275.284c-1.12,0-42.648,0-42.648,0c0.744-8,1.24-8.688,1.256-13.472 c0.128-42.672-28.36-79.952-70.032-89.136c-23.752-5.232-46.424-1.368-65.184,8.76c-22.888-34.064-60.808-57.04-104.272-59.696 c-5.592-0.768-11.256-1.224-17.056-1.224C57.432,120.516,0,179.78,0,252.836c0,38.072,15.688,72.304,40.648,96.44 c22.072,24.488,52.72,40.312,89.008,42.944c0,0,295.432,1.464,296.552,1.464c29.712,0,53.792-27.208,53.792-59.208 C480,302.492,455.912,275.284,426.208,275.284z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRain1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rain-1.23e71edd.svg";
export { ForwardRef as ReactComponent };